import { FormInstance, Row } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useGetDisbursementsDate } from "./hooks/useGetDisbursementsDate";
import { useOpenSideBar } from "./hooks/useOpenSidebar";
import { createPortal } from "react-dom";
import { useActions } from "./hooks/useActions";
import { DisbursementsTable } from "./components/DisbursementsTable";
import { useGetFormattedValues } from "./hooks/useGetFormattedValues";
import { IPayeeDisbursementsBase } from "../../../../../types/PayeeDisbursements";
import { useCallback, useState } from "react";

type DisbursementsProps = {
  instance: any;
  form: FormInstance;
  isFormDisabled: boolean;
  isPaymentPosted: boolean;
  isHistoryEdited: boolean;
  isHistoryOpened: boolean;
  reset: (value: IPayeeDisbursementsBase[]) => Promise<0 | 1>;
};

export const Disbursements = ({
  instance,
  form,
  isFormDisabled,
  isPaymentPosted,
  reset,
  isHistoryEdited,
  isHistoryOpened
}: DisbursementsProps) => {
  const { payeesNumber, contractId, disbursements } = useGetFormattedValues(instance);

  const [isDisclamerActive, setIsDisclamerActive] = useState(false);

  const resetWrapper = useCallback(
    async (value: IPayeeDisbursementsBase[]) => {
      const result = await reset(value);
      setIsDisclamerActive(true);
      return result;
    },
    [reset]
  );

  const { openDeleteModal, saveRecord } = useActions(disbursements, resetWrapper);

  const { formWrapper, isOpen, toggleSideBarSideBar } = useOpenSideBar(
    contractId,
    payeesNumber,
    isFormDisabled,
    isPaymentPosted,
    saveRecord,
    openDeleteModal,
    isHistoryOpened
  );

  const { dateValue } = useGetDisbursementsDate(instance);

  const onNewPayee = useCallback(() => toggleSideBarSideBar({}), [toggleSideBarSideBar]);

  return (
    <Row className="d-block">
      <Row className="align-center justify-space-between w-100">
        <p className="my-0 text-md card-header w-500">Payee Disbursements ({disbursements.length})</p>
        <p className="my-0 text-sm">{dateValue}</p>
      </Row>
      <Row>
        {disbursements.length > 0 ? (
          <DisbursementsTable
            disbursements={disbursements}
            openDeleteModal={openDeleteModal}
            onOpenSideBar={toggleSideBarSideBar}
            isFormDisabled={isFormDisabled}
            isPaymentPosted={isPaymentPosted}
          />
        ) : (
          <p className="my-4 text-sm title">No Payee Added</p>
        )}
      </Row>
      {isHistoryEdited && (
        <Row>
          <span className="ant-btn-link text-sm logo-cursor" onClick={onNewPayee}>
            + New Payee
          </span>
        </Row>
      )}
      {isDisclamerActive && !isHistoryOpened && (
        <Row className="align-start mt-4 disclamer-disbs">
          <ExclamationCircleOutlined className="warning disclamer-icon" />
          <Row className="ml-2 disclamer-body">
            <span className="warning text-sm">
              A Payee Disbursement has been manually updated. Please review and update other disbursements if needed
            </span>
          </Row>
        </Row>
      )}
      {isOpen && createPortal(formWrapper, document.body)}
    </Row>
  );
};
